import { useState,  useEffect, createRef } from 'react';
import logo from '../img/elizak_p.png'
import emptyImg from '../img/empty_image.png'
import Config from '../Config';


function ImageZoom(props)
{

    const [view, setView] = useState("btn");


    const showZoom = () => {
        setView('zoom');
    }

    const closeZoom = () => {
        setView('btn');
    }


   


    if(props.b64.length < 1)
    {
        return null;
    }



    if(view == 'zoom')
    {
        return (
            <div className='zoomImgBG' onClick={closeZoom}>
                  
                    <img src={ props.b64 }   onClick={closeZoom} />
                  
            </div>
        )
    }

     
    return (
        <div className='simply_link' onClick={showZoom}>powiększ grafikę<br/></div>
    )
}



export default ImageZoom;